import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslocoService } from '@jsverse/transloco';
import {
  EducationEnum,
  ExtendedGenderEnum,
  LengthOfPracticeEnum,
  ReadTeacherAdditionalInformation,
  RegionEnum,
  TeacherAdditionalInfoService,
} from '@isophi/pap-api';
import { NgxSpinnerService } from 'ngx-spinner';
import { finalize, Observable, of, tap } from 'rxjs';
import { HelperService } from '../../../core/services/helper.service';
import { HandleErrorService } from '../../services/handle-error.service';
import { ToastService } from '@isophi/core-ui';
import { educationLevelData, lengthOfPracticeData, regionData } from '../../../modules/registration/pages/registration/data';

@Component({
    selector: 'app-more-info-form',
    templateUrl: './more-info-form.component.html',
    styleUrls: ['./more-info-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class MoreInfoFormComponent implements OnInit {
  moreInfoForm: FormGroup;

  educationLevel: { [key: string]: string }[] = [];

  lengthOfPractices: { [key: string]: string }[] = [];

  regions: { [key: string]: string }[] = [];

  GenderEnum = ExtendedGenderEnum;

  additionalInfo$: Observable<ReadTeacherAdditionalInformation | null> = of(null);

  constructor(
    public activeModal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private helperService: HelperService,
    private parentAdditionalInfoService: TeacherAdditionalInfoService,
    private toastService: ToastService,
    private spinner: NgxSpinnerService,
    private translocoService: TranslocoService,
    private handleErrorService: HandleErrorService
  ) {
    this.educationLevel = this.helperService.prepareData(educationLevelData, EducationEnum);
    // Reorder educationLevel
    [this.educationLevel[1], this.educationLevel[2]] = [this.educationLevel[2], this.educationLevel[1]];
    this.lengthOfPractices = this.helperService.prepareData(lengthOfPracticeData, LengthOfPracticeEnum);
    this.regions = this.helperService.prepareData(regionData, RegionEnum);

    this.moreInfoForm = this.formBuilder.group({
      education: [null, Validators.required],
      lengthOfPractice: [null, Validators.required],
      region: [null, Validators.required],
      extendedGender: ['', Validators.required],
      contractConsent: [false, Validators.required],
    });
  }

  ngOnInit(): void {
    this.additionalInfo$ = this.parentAdditionalInfoService.teacherAdditionalInfoGetAdditionalInfoRetrieve().pipe(
      tap((additionalInfo) => {
        if (additionalInfo) {
          this.moreInfoForm.patchValue(additionalInfo);
        }
      })
    );
  }

  onSubmit(): void {
    if (!this.moreInfoForm.valid) {
      this.moreInfoForm.markAllAsTouched();
      this.toastService.warning(this.translocoService.translate('shared/notValid'));
      return;
    }

    this.spinner.show();
    this.parentAdditionalInfoService
      .teacherAdditionalInfoUpdateAdditionalInfoUpdate(this.moreInfoForm.value)
      .pipe(finalize(() => this.spinner.hide()))
      .subscribe({
        next: () => {
          this.toastService.success(this.translocoService.translate('shared/additionalInfoSuccess'));
          this.helperService.fillQuestionnaire();
          this.activeModal.close();
        },
        error: (e) => {
          this.handleErrorService.handleFormError(e, '', 'shared/additionalInfoError');
        },
      });
  }
}
